import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AdminAuthProvider, useAdminAuth } from "./context/AdminAuthContext";
import LandingPage from "./pages/LandingPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ChangePassword from "./pages/ChangePassword";
import UpgradeSuccess from "./pages/UpgradeSuccess";
import UpgradeCancel from "./pages/UpgradeCancel";


// Protected Route for Admin
const ProtectedAdminRoute = ({ children }) => {
  const { admin, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/admin" replace />;
  }

  if (admin.must_change_password) {
    return <Navigate to="/admin/change-password" replace />;
  }

  return children;
};

const PasswordChangeRoute = ({ children }) => {
  const { admin, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

function AppContent() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />

      <Route path="/upgrade/success" element={<UpgradeSuccess />} />
      <Route path="/upgrade/cancel" element={<UpgradeCancel />} />

      <Route path="/admin" element={<AdminLogin />} />
      <Route 
        path="/admin/change-password" 
        element={
          <PasswordChangeRoute>
            <ChangePassword />
          </PasswordChangeRoute>
        } 
      />
      <Route 
        path="/admin/dashboard" 
        element={
          <ProtectedAdminRoute>
            <AdminDashboard />
          </ProtectedAdminRoute>
        } 
      />

      <Route path="/admin-paramsnap" element={<Navigate to="/admin" replace />} />
      <Route path="/admin-paramsnap/dashboard" element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="/admin-paramsnap/*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <AppContent />
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
